import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * A command sent by the rovo inline input box client to abort the ongoing message
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to abort the ongoing message.
 */
export const InlineInputBoxAbortMessageCommand: CommandConstructor<
	CommandProperties & { conversationId?: string },
	SerializableValue
> = createCommand<CommandProperties & { conversationId?: string }>(
	'inline-input-box-abort-message-command',
);
